/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SettingV2 {
  date?: number;
  oficialExchangeRate?: number;
  oficialExchangeRateUsd?: number;
  spread?: number;
  iof?: number;
  operacionalMargin?: number;
  pixProcessmentFee?: number;
  cardProcessmentFee?: number;
  debitCardProcessmentFee?: number;
  antecipationFee?: number;
  financingFee?: number;
  twoMonthsFee?: number;
  threeMonthsFee?: number;
  fourMonthsFee?: number;
  fiveMonthsFee?: number;
  sixMonthsFee?: number;
  sevenMonthsFee?: number;
  eightMonthsFee?: number;
  nineMonthsFee?: number;
  tenMonthsFee?: number;
  elevenMonthsFee?: number;
  twelveMonthsFee?: number;
}
